import { MVT_EVENTS } from "@/sdk/event-manager"
import { standardizeUrl } from "@/lib/url-helpers"

export const isTrackedDownloadLink = (url: string): boolean =>
  /\.(pdf|docx?|xlsx?|zip|rar|csv|pptx?)$/i.test(url)

export const trackLinkClick = (url: string, text: string): void => {
  if (!url || !window.$mvt) return

  const data = {
    data: {
      text: text?.replace(/\n/g, " ").trim(),
      href: standardizeUrl(url)
    }
  }

  window.$mvt.trackEvent(MVT_EVENTS.LINK_CLICK, data)

  if (isTrackedDownloadLink(url)) {
    window.$mvt.trackEvent(MVT_EVENTS.FILE_DOWNLOAD, data)
  } else if (url.startsWith("mailto:")) {
    window.$mvt.trackEvent(MVT_EVENTS.EMAIL_CLICK, data)
  } else if (url.startsWith("tel:")) {
    window.$mvt.trackEvent(MVT_EVENTS.TELEPHONE_CLICK, data)
  }
}
